/***
*
*   ONBOARDING LAYOUT
*   Simple layout to focus on user onboarding actions
*
**********/

import Style from './onboarding.tailwind.js';
import { useTranslation } from 'components/lib';

export function OnboardingLayout(props) {

  const { t } = useTranslation();

  return (
    <main className={Style.onboarding}>

      {<props.children t={t}/>}

    </main>
  );
}